module.exports = __webpack_public_path__ + "static/WTP4-0b43d5f91ab90b58e174de06e019acc1.jpg";